import AddFilterDropdown from './AddFilterDropdown'

/**
 * Barra horizontal con chips de filtros PRESENTES + dropdown "+ Agregar filtro" + "Limpiar".
 * La presencia de chips la maneja el hook (presentKeys), separada de los valores: un filtro
 * recien agregado aparece aunque su valor este vacio.
 *
 * @param {string[]} presentKeys - chip keys presentes (date, include_ic, ... agent)
 * @param {Function} addFilterKey - (chipKey) => void
 * @param {Function} resetFilters - () => void
 * @param {boolean} isAdmin
 * @param {Function} renderChip - (key, filters, updateFilter) => ReactNode
 * @param {Object} filters
 * @param {Function} updateFilter - (key, value) => void
 */
export default function FilterChipsBar({ presentKeys, addFilterKey, resetFilters, isAdmin, renderChip, filters, updateFilter }) {
  return (
    <div className="flex items-center gap-2 flex-wrap px-4 py-2 bg-blue-50/50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800">
      {presentKeys.length === 0 && (
        <span className="text-sm text-gray-500 dark:text-gray-400">Sin filtros activos —</span>
      )}
      {presentKeys.map(key => renderChip(key, filters, updateFilter))}
      <AddFilterDropdown activeKeys={presentKeys} onAddFilter={addFilterKey} isAdmin={isAdmin} />
      {presentKeys.length > 0 && (
        <button
          onClick={resetFilters}
          className="ml-auto text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 underline"
          type="button"
        >
          Limpiar filtros
        </button>
      )}
    </div>
  )
}
